import React from 'react';
import Input from "../Input-new/Input";
import PropTypes from "prop-types";
import Dropdown from "../Dropdown/Dropdown";
import Textarea from "../Textarea-new/Textarea";
import Control from "../Control";
import SelectTeam from '../SelectTeam-new/SelectTeam';
import { getTenantSubcategoryMT, getTenantSubcategorySTNL } from '../../utils';

const SellerForm = ({theme = 'white', data, paneIndex, isFilter = false, handleSubmit, handleCancel, handleParentChange, handleParentDropdownChange, handlePaneChange}) => {
    const panes = [
        (
            <React.Fragment>
                <div className={`form-title ${theme}`}>{isFilter ? 'Seller' : 'Add Seller'}</div>
                <Input theme={theme}
                       valueType='text'
                       name='FIRST_NAME'
                       label='First Name'
                       value={data.FIRST_NAME}
                       required={!isFilter}
                       handleParentChange={handleParentChange}
                />
                <Input theme={theme}
                       valueType='text'
                       name='LAST_NAME'
                       label='Last Name'
                       value={data.LAST_NAME}
                       required={!isFilter}
                       handleParentChange={handleParentChange}
                />
                <Input theme={theme}
                       valueType='phone'
                       name='PHONE'
                       label='Phone'
                       value={data.PHONE}
                       handleParentChange={handleParentChange}
                />
                <Input theme={theme}
                       valueType={isFilter ? 'text' : 'email'}
                       name='EMAIL'
                       label='Email'
                       value={data.EMAIL}
                       handleParentChange={handleParentChange}
                />
                <Dropdown theme={theme}
                          optionsType='profiles'
                          value={data.PROFILE}
                          valueKey='PROFILE'
                          label='Profile'
                          data={data}
                          handleParentChange={handleParentDropdownChange}
                />
                <Dropdown theme={theme}
                          optionsType='sellerStatus'
                          value={data.STATUS}
                          valueKey='STATUS'
                          label='Seller Status'
                          data={data}
                          handleParentChange={handleParentDropdownChange}
                />
                {
                    !isFilter &&         
                    <div className='last-modified'>Last modified on: {data.LAST_MODIFIED}</div>
                }
                <Textarea theme={theme}
                        name='NOTES'
                        label='Notes'
                        value={data.NOTES}
                        maxWidth='100%'
                        handleParentChange={handleParentChange}
                />
            </React.Fragment>
        ),
        (
            <React.Fragment>
                <div className={`form-title ${theme}`}>{isFilter ? 'Seller Company' : 'Add Seller Company'}</div>
                <Input theme={theme}
                       valueType='text'
                       name='COMPANY_NAME'
                       label='Company Name'
                       value={data.COMPANY_NAME}
                       handleParentChange={handleParentChange}
                />
                <Input theme={theme}
                       valueType='text'
                       name='COMPANY_ADDRESS'
                       label='Company Address'
                       value={data.COMPANY_ADDRESS}
                       handleParentChange={handleParentChange}
                />
                <Input theme={theme}
                       valueType='text'
                       name='COMPANY_CITY'
                       label='City'
                       value={data.COMPANY_CITY}
                       handleParentChange={handleParentChange}
                />
                <div className='form-address'>
                    <div className='form-state'>
                        <Dropdown theme={theme}
                                  optionsType='states'
                                  optionKey='abbr'
                                  optionLabelKey='name'
                                  value={data.COMPANY_STATE}
                                  valueKey='COMPANY_STATE'
                                  label='State'
                                  data={data}
                                  handleParentChange={handleParentDropdownChange}
                        />
                    </div>
                    <div className='form-zip'>
                        <Input theme={theme}
                               valueType='text'
                               name='COMPANY_ZIP'
                               label='Zip'
                               value={data.COMPANY_ZIP}
                               handleParentChange={handleParentChange}
                        />
                    </div>
                </div>
            </React.Fragment>
        ),
    ];

    return (
        <form className='form' onSubmit={handleSubmit}>
            <div className='form-slider'>
                {
                    panes.map((el, key) => (
                        <Control key={key} onClick={()=> handlePaneChange(key)}>
                            <div className={`form-slider-icon ${theme}${key === paneIndex ? ' active' : ''}`}/>
                        </Control>
                    ))
                }
            </div>
            {
                panes[paneIndex]
            }
            {
                isFilter ?
                    <div className='filter-buttons'>
                        <button type='button' className='button-new negative dark' onClick={handleCancel}>Clear</button>
                        <button className='button-new positive'>Apply</button>
                    </div>
                    :
                    <React.Fragment>
                        <button type='button' className='button-new negative' onClick={handleCancel}>Cancel</button>
                        <button className='button-new positive'>Submit</button>
                    </React.Fragment>
            }
        </form>
    )
};

SellerForm.propTypes = {
    theme: PropTypes.oneOf(['white', 'dark']),
    data: PropTypes.object.isRequired,
    paneIndex: PropTypes.number.isRequired,
    isFilter: PropTypes.bool,
    handleSubmit: PropTypes.func.isRequired,
    handleCancel: PropTypes.func.isRequired,
    handleParentChange: PropTypes.func.isRequired,
    handleParentDropdownChange: PropTypes.func.isRequired,
    handlePaneChange: PropTypes.func.isRequired,
};

export default SellerForm;